'use client';

import { BlogCategoryPage } from '@/components/pages/blog/BlogCategoryPage';
import { useAppNavigate } from '../../_lib/useAppNavigate';
import type { BlogPostDocument, BlogCategoryDocument } from '@/firebase/blog-db';

interface BlogCategoryClientProps {
  categorySlug: string;
  category: BlogCategoryDocument | null;
  categories: BlogCategoryDocument[];
  posts: BlogPostDocument[];
  hasMore: boolean;
}

export default function BlogCategoryClient({ categorySlug, category, categories, posts, hasMore }: BlogCategoryClientProps) {
  const navigate = useAppNavigate();
  return (
    <BlogCategoryPage
      categorySlug={categorySlug}
      onNavigate={navigate}
      category={category}
      categories={categories}
      posts={posts}
      hasMore={hasMore}
    />
  );
}
